module.exports = __webpack_public_path__ + "img/gg_logo.40367309.png";